import { GeoJSONSource, GeoJSONSourceSpecification } from 'mapbox-gl';
import LivingMap from '../map';
import { FeatureCollection, GeoJsonProperties, Geometry } from 'geojson';

/**
 * @class
 * This class represents a geoJSON mapping data source on our map.
 */
export class GeoJSONSourceProxy {
  private readonly LMMap: LivingMap;
  private readonly id: string;

  private geojson: GeoJSONSourceSpecification;

  constructor(id: string, data: GeoJSONSourceSpecification, LMMap: LivingMap) {
    this.LMMap = LMMap;
    this.geojson = data;
    this.id = id;
  }

  /**
   * Sets the GeoJSON data and re-renders the map after setting it.
   * @param  {FeatureCollection<Geometry>} data
   * @returns void
   */
  public setData(data: FeatureCollection<Geometry>): void {
    const map = this.LMMap.getMapboxMap();
    const source = map.getSource(this.id) as GeoJSONSource;
    if (source) source.setData(data);
    this.geojson.data = data;
  }

  /**
   * Retrieve the data previously set.
   * @param  {FeatureCollection<Geometry>} data
   * @returns void
   */
  public getData(): FeatureCollection<Geometry, GeoJsonProperties> {
    const data = this.geojson.data as FeatureCollection<
      Geometry,
      GeoJsonProperties
    >;
    return data;
  }

  /**
   * Retrieves the raw geoJSON representation.
   * @param  {FeatureCollection<Geometry>} data
   * @returns void
   */
  public getGeojson(): GeoJSONSourceSpecification {
    return this.geojson;
  }
}
